module.exports = __webpack_public_path__ + "img/015.81c30d2f.png";